import MeetingsManagement from "./meetingsManagement";
export default MeetingsManagement;